import request from './request'

export default {
    install(Vue, options = {}) {
        // 创建访问追踪方法
        Vue.prototype.$trackVisit = async function (pageUrl) {
            try {
                await request.post('/api/statistics/log', {
                    page_url: pageUrl
                });
            } catch (error) {
                console.error('记录访问失败:', error);
            }
        }

        // 等待 router 实例准备好后再添加钩子
        Vue.mixin({
            beforeCreate() {
                // 只在根组件中执行一次
                if (this.$root === this && this.$router) {
                    this.$router.afterEach((to) => {
                        this.$trackVisit(to.fullPath);
                    });
                }
            }
        });
    }
} 